import { cr } from "fire-wind-water";
import { rs } from "../../sbase";

export function $extras(arr) {
  const json = {
    extras: {},
    groups: {}
  };
  cr.each(arr, m => {
    json[m.usePage] = {};
    cr.each(m.extra, d => {
      json.extras[d.key] = d.value;
      json.groups[d.key] = d.value;
      json[m.usePage][d.key] = d.value;
      cr.each(d.items, o => {
        if (cr.isArray(o.asHideModule)) {
          if (
            o.asHideModule.indexOf(rs.moduleId) !== -1 ||
            o.asHideModule.indexOf(parseInt(rs.moduleId)) !== -1
          ) {
            return;
          }
        }
        json.extras[o.key] = o.value;
        json[m.usePage][o.key] = o.value;
      });
    });
  });
  return json;
}

export function $extraItem(value, str, defaultVal) {
  if (value && str) {
    const arr = str.split(".");
    let v = null;
    let m = value;
    for (let i = 0; i < arr.length; i++) {
      v = m[arr[i]];
      if (v) {
        m = v;
      } else {
        if (v === undefined && defaultVal) {
          m = defaultVal
        } else {
          m = "";
        }
        break;
      }
    }
    return m;
  }
  return value;
}
